module.exports = __webpack_public_path__ + "img/caseBuilder-chemicalEngineer.173d84e5.webp";